export const ROUTES_CONFIG = {
    client:{
        base:'https://crmcliente.biccrm.com/api/client/',
        // base:'http://localhost:5001/api/client/',
        endpoints:{
            get:'',
            getByDocument:'findOne',
            saveEntradaVisitantes:'saveEntradaVisitantes',
            getCanalAtencion:'getCanalAtencion',
            getTipoFpqrs:'getTipoFpqrs',
            getCategoriaFpqrs:'getCategoriaFpqrs',
            getArea:'getArea',
            getTipoDocumento:'getTipoDocumento',
            getCiudad:'getCiudad',
            getBarrio:'getBarrio',
            getMotivoSolicitud:'getMotivoSolicitud',
            insertOrEditFpqrs:'insertOEditFpqrs',
            getFpqrs:'getFpqrs',
            getFilesFpqrs:'getFilesFpqrs',
            getReferencias:'getReferencias',
            insertOrEditClient:'insertOrEditClient',
            getClient:'getClient',
            getComercial:'getComercial',
            getPiso:'getPiso',
            getPlazoleta:'getPlazoleta',
            getTipoStand:'getTipoStand',
            insertOrEditStand:'insertOrEditStand',
            insertOrEditQuoteComercial:'insertOrEditQuoteComercial',
            asambleaFirma:'asambleaFirma',
            searchAsambleistas:'searchAsambleistas'
        }
    },
    usuario:{
        base:'https://crmusuario.biccrm.com/api/usuario/',
        // base:'http://localhost:5004/api/usuario/',
        endpoints:{
            login:'login',
        }
    },
    almacenes:{
        base:'https://crmalmacen.biccrm.com/api/almacenes/',
        // base:'http://localhost:5006/api/almacenes/',
        endpoints:{
            getHorarioAlmacenes:'findAll',
            updateHorarioAlmacen:'updateHorarioAlmacen',
            getImagenHorarioAlmacen:'imagenHorarioAlmacen',
            getAlmacenes:'getAlmacenes',
            insertHorarioAlmacen:'inserHorarioAlmacen',
            deleteHorarioAlmacen:'deleteHorarioAlmacen'
        }
    },
    estadisticas:{
        base:'https://crmestadistica.biccrm.com/api/estadisticas/',
        // base:'http://localhost:5007/api/estadisticas/',
        endpoints:{
            getReferencia:'referencia',
            getTipoCliente:'tipoCliente',
            getTipoGrupo:'tipoGrupo',
            getSorteos:'sorteos',
            estadistiscaSigma:'estadistiscaSigma',
            createListContact:'createListContact',
            getListContact:'getListContact',
            getCategory:'getCategory',
            deleteListContact:'deleteListContact',            
        }
    },
    notificacion:{
        base:'https://crmnotifications.biccrm.com/api/notifications',
        // base:'http://localhost:5003/api/notifications',
        endpoints:{
            sendEmail:''
        }
    },
    facturas:{
        base:'https://crmfacturas.biccrm.com/api/facturas/',
        // base:'http://localhost:5005/api/facturas/',
        endpoints:{
            ocr:'',
            preCreateBillOcr:'preCreateBillOcr',
            ocrJumpCube:'ocrJumpCube',
            getBillsOcrPending:'getBillsOcrPending',
            createBill:'createBill',
            getInfoBenchMarking:'getInfoBenchMarking',
            getVirtualBill:'getVirtualBill',
            getPremiosEntregar:'getPremiosEntregar',
            selectGift:'selectGift'
        }
    },
    admin:{
        base:'https://crmadmin.biccrm.com/api/admin/',
        // base:'http://localhost:5008/api/admin/',
        endpoints:{
            insertOrEditTemplate:'insertOrEditTemplate',
            listTemplate:'listTemplate'
        }
    }
};